<template>
  <MultiCheckboxInput
    :id="id"
    ref="multiCheckbox"
    :content="content"
    :payload="payload"
    :expand-button-text="expandButtonText"
    @change_multicheckbox="change_multicheckbox"
  />
</template>

<script>
import MultiCheckboxInput from '../multiCheckboxInput/MultiCheckboxInput.vue';
import { getCustomEvent } from '@/helpers/custom-events';
import { toBoolean } from '@/helpers/transform';

export default {
  name: 'VsMultiCheckbox',
  components: {
    MultiCheckboxInput,
  },
  expose: ['resetValues'],
  props: {
    id: { type: String },
    content: { type: String },
    payload: { type: String },
    expandButtonText: { type: String },
    enableReset: { type: String, default: 'false' },
  },
  mounted() {
    if (toBoolean(this.enableReset)) {
      document.addEventListener('reset_multicheckbox_' + this.id, (e) => {
        this.resetValues(e.detail);
      });
    }
  },
  methods: {
    change_multicheckbox(e) {
      this.$el.dispatchEvent(getCustomEvent('change_multicheckbox', e));
    },
    resetValues(content) {
      this.$refs.multiCheckbox.resetValues(content);
    },
  },
};
</script>
